/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ exercise: NonNullable<unknown>, set: NonNullable<unknown>, total: NonNullable<unknown> }} Coach_Live_RestInputs */

const en_us2_coach_live_rest = /** @type {(inputs: Coach_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resting · next ${i?.exercise}, set ${i?.set} of ${i?.total}`)
};

const pt_br2_coach_live_rest = /** @type {(inputs: Coach_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descansando · a seguir ${i?.exercise}, série ${i?.set} de ${i?.total}`)
};

const es_419_coach_live_rest = /** @type {(inputs: Coach_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descansando · sigue ${i?.exercise}, serie ${i?.set} de ${i?.total}`)
};

const pt_pt2_coach_live_rest = /** @type {(inputs: Coach_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A descansar · a seguir ${i?.exercise}, série ${i?.set} de ${i?.total}`)
};

const fr_fr2_coach_live_rest = /** @type {(inputs: Coach_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Repos · ensuite ${i?.exercise}, série ${i?.set} sur ${i?.total}`)
};

const de_de2_coach_live_rest = /** @type {(inputs: Coach_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pause · als Nächstes ${i?.exercise}, Satz ${i?.set} von ${i?.total}`)
};

const it_it2_coach_live_rest = /** @type {(inputs: Coach_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recupero · poi ${i?.exercise}, serie ${i?.set} di ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Resting · next {exercise}, set {set} of {total}" |
*
* @param {Coach_Live_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_live_rest = /** @type {((inputs: Coach_Live_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Live_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_live_rest(inputs)
	if (locale === "es-419") return es_419_coach_live_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_live_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_live_rest(inputs)
	if (locale === "de-DE") return de_de2_coach_live_rest(inputs)
	if (locale === "it-IT") return it_it2_coach_live_rest(inputs)
	return en_us2_coach_live_rest(inputs)
});
export { coach_live_rest as "coach.live_rest" }